import React, { useContext, useEffect, useState } from 'react';
import { StyleSportsPicksContainer, StyledTextarea, StyledContent } from './SportsPicks.styled';
import TopBar from './TopBar';
import { PlayerContext } from '../../contexts/playerContext';
import { useSportsPicks } from '../../hooks/useSportsPicks';
import Button from '../Button/Button';
import {
    BtnBold,
    BtnBulletList,
    BtnClearFormatting,
    BtnItalic,
    BtnLink,
    BtnNumberedList,
    BtnRedo,
    BtnStrikeThrough,
    BtnStyles,
    BtnUnderline,
    BtnUndo,
    Editor,
    EditorProvider,
    HtmlButton,
    Separator,
    Toolbar,
} from 'react-simple-wysiwyg';

const SportsPicks = () => {
    const playerContext = useContext(PlayerContext);
    const [selectedDate, setSelectedDate] = useState<string>('');
    const [content, setContent] = useState<string>('');

    const { sportsPick, addNewSportsPicks } = useSportsPicks(selectedDate);
    useEffect(() => {
        const today = new Date().toISOString().split('T')[0]; // Format: YYYY-MM-DD
        setSelectedDate(today);
    }, []);


    useEffect(() => {
        setContent('')
    }, [sportsPick])
    return (
        <StyleSportsPicksContainer>
            <TopBar selectedDate={selectedDate} setSelectedDate={setSelectedDate} />
            {
                playerContext?.role != 1 ? (
                    <StyledContent dangerouslySetInnerHTML={{ __html: sportsPick?.sportsPickData ? sportsPick?.sportsPickData.sportsPick.content : "" }} />
                )
                    :
                    sportsPick?.status ? (
                        <StyledContent dangerouslySetInnerHTML={{ __html: sportsPick?.sportsPickData ? sportsPick?.sportsPickData.sportsPick.content : "" }} />
                    )
                        :
                        (
                            <>
                                <StyledTextarea>
                                    <EditorProvider>
                                        <Editor value={content} onChange={(e) => setContent(e.target.value)} style={{ color: 'white' }} >
                                            <Toolbar>
                                                <BtnUndo />
                                                <BtnRedo />
                                                <Separator />
                                                <BtnBold />
                                                <BtnItalic />
                                                <BtnUnderline />
                                                <BtnStrikeThrough />
                                                <Separator />
                                                <BtnNumberedList />
                                                <BtnBulletList />
                                                <Separator />
                                                <BtnLink />
                                                <BtnClearFormatting />
                                                <HtmlButton />
                                                <Separator />
                                                <BtnStyles />
                                            </Toolbar>
                                        </Editor>
                                    </EditorProvider>
                                </StyledTextarea>
                                <Button padding='1rem' textSize='12px' text='Save' image={null} size='big' event={() => addNewSportsPicks(content, selectedDate)} />
                            </>
                        )
            }
        </StyleSportsPicksContainer>
    );
}

export default SportsPicks;
